/**
 * @module Navigation
 * @description
 */
import React, { FC } from 'react';
import styles from './styles/Navigation.module.css';

interface Props {
  children: JSX.Element;
  className?: string;
  ariaLabel: string;
}

const Navigation: FC<Props> = ( { ...props } ) => {
  const {
    children,
    className,
    ariaLabel
  } = props;

  return (
    <nav
     className={ `${ styles.navigation } ${ className }` }
     aria-label={ ariaLabel }
     role="navigation"
   >
     { children }
   </nav>
  )
};

Navigation.displayName = 'Navigation';

export default Navigation;
